import Cookies from "js-cookie";

/**
 * cookieStorage describes a custom storage that leverages cookies for persisting
 * some data.
 *
 * This function is used in conjunction with Jotai for persisting atom values.
 */
export const cookieStorage = {
	getItem: (key: string) => {
		return Cookies.get(key) ?? undefined;
	},
	setItem: (key: string, value: string | undefined) => {
		if (value) {
			Cookies.set(key, value);
		} else {
			Cookies.remove(key);
		}
	},
	removeItem: (key: string) => {
		Cookies.remove(key);
	},
};

/**
 * Defines all storage keys.
 */
export enum StorageKeys {
	// Use by application local storage.
	UserData = "user-data",
	Preferences = "preferences",
	PeriodFilter = "period-filter",

	// Used by cookies.
	JwtToken = "token",
}
